import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Observable } from 'rxjs';
import {
  WorkerGroup,
  WorkerWorkGroupCreate,
  WorkerWorkPlaceGroup,
} from '../models';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Cookies } from 'typescript-cookie';

@Injectable({
  providedIn: 'root',
})
export class WorkerWorkplaceGroupService {
  private apiService = inject(ApiService);
  private readonly apiUrl: string = environment.apiUrl;
  private http = inject(HttpClient);
  business = Cookies.get(`bussinesId`);

  storeWorkerWorkplaceGroup(data: WorkerWorkGroupCreate, bussinesId: number) {
    const business = Cookies.get(`bussinesId`);
    return this.apiService.store(
      `workerWorkPlaceGroup?workplaceGroupId=${data.workplaceGroupId}&workerGroupId=${data.workerGroupId}&business_id=${bussinesId}`,
      undefined
    );
  }

  deleteWorkerWorplaceGroup(
    idGroupUser: number,
    idGroupWork: number,
    businessId: number
  ): Observable<any> {
    return this.http.delete(
      `${this.apiUrl}workerWorkPlaceGroup?workplaceGroupId=${idGroupUser}&workerGroupId=${idGroupWork}&business_id=${businessId}`
    );
  }

  getWorkerWorkplaceGroups(): Observable<WorkerWorkPlaceGroup[]> {
    return this.apiService.getAll('');
  }

  getWorkerWorkplaceGroup(id: number): Observable<WorkerWorkPlaceGroup> {
    return this.apiService.getById('', id);
  }

  updateWorkerWorkplaceGroup(
    idGroupUser: number,
    idGroupWork: number,
    data: WorkerWorkGroupCreate,
    bussinesId: number
  ) {
    const business = Cookies.get(`bussinesId`);
    return this.apiService.update(
      `workerWorkPlaceGroup?workplaceGroupId=${idGroupWork}&workerGroupId=${idGroupUser}&workplaceGroupIdNew=${data.workplaceGroupId}&workerGroupIdNew=${idGroupUser}&business_id=${bussinesId}`,
      undefined,
      idGroupUser
    );
  }
}
